import React from 'react'
import { Radio as MuiRadio, RadioProps } from '@mui/material'
import { styled } from '@mui/material/styles'
import CheckIcon from '@mui/icons-material/Check'

interface CustomRadioProps extends RadioProps {}

const UncheckedIcon = styled('span')(() => ({
  display: 'flex',
  width: 24,
  height: 24,
  border: '2px solid #B0BEC5',
  borderRadius: '50%',
  backgroundColor: 'white',
}))

const CheckedIcon = styled('span', {
  shouldForwardProp: (prop) => prop !== '$disabled',
})<{ $disabled?: boolean }>(({ $disabled, theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: 24,
  height: 24,
  backgroundColor: $disabled ? '#B0BEC5' : '#4CAF50',
  borderRadius: '50%',
  color: 'white',
}))

const StyledRadio = styled(MuiRadio)(({ theme }) => ({
  padding: theme.spacing(0.5),
  '& .MuiSvgIcon-root': {
    width: 14,
    height: 14,
    border: '2px solid #B0BEC5',
    borderRadius: '50%',
    backgroundColor: 'white',
  },
  '&.Mui-checked': {
    color: theme.palette.success.light,
    '& .MuiSvgIcon-root': {
      backgroundColor: theme.palette.success.light,
      color: 'white',
      border: 'none',
    },
  },
}))

export const Radio = (props: CustomRadioProps) => (
  <StyledRadio
    icon={<UncheckedIcon />}
    checkedIcon={
      <CheckedIcon $disabled={props.disabled}>
        <CheckIcon style={{ fontSize: 16, backgroundColor: 'transparent' }} />
      </CheckedIcon>
    }
    {...props}
  />
)
